import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, Router} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';

export interface Breadcrumb {
    label: string;
    url: string;
}

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {

    breadcrumbs: BehaviorSubject<Breadcrumb[]> = new BehaviorSubject<Breadcrumb[]>([]);
    breadcrumbs$: Observable<Breadcrumb[]> = this.breadcrumbs.asObservable();

    constructor(private router: Router) {}

    generateBreadcrumbs(route: ActivatedRouteSnapshot): void {
        const breadcrumbs: Breadcrumb[] = [];
        let currentRoute: ActivatedRouteSnapshot = route;
        let url: string = '';

        // Always add Home breadcrumb
        breadcrumbs.push({
            label: 'Home',
            url: '/'
        });

        // Build breadcrumbs from route hierarchy
        while (currentRoute) {
            const path: string = currentRoute.routeConfig?.path;
            if (path && path !== '') {
                if (path === ':number') {
                    const number: string = currentRoute.url.join('/');
                    url += `/${number}`;
                    breadcrumbs.push({
                        label: number,
                        url: url
                    });
                } else {
                    url += `/${path}`;
                    const label: string = this.formatLabel(path);
                    breadcrumbs.push({
                        label: label,
                        url: url
                    });
                }
            }
            currentRoute = currentRoute.firstChild!;
        }

        this.breadcrumbs.next(breadcrumbs);
    }

    private formatLabel(path: string): string {
        return path
            .split('-')
            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }
}
